import { render, staticRenderFns } from "./PartnerSettingsNavigation.vue?vue&type=template&id=3a9c10ce"
import script from "./PartnerSettingsNavigation.vue?vue&type=script&lang=ts"
export * from "./PartnerSettingsNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports